import { useAuth0 } from '@auth0/auth0-react';
import { Button, SxProps, Theme } from '@mui/material';
import React from 'react';
import { LogoutStyledButton } from '../../../styled-components/GlobalStyledComponents';
import useTranslate from '../../../hooks/useTranslate';

export const LogoutButton = (props: { sx?: SxProps<Theme> }) => {
  const { logout } = useAuth0();
  const t = useTranslate();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <LogoutStyledButton variant="contained" onClick={handleLogout} sx={props.sx}>
      {t('logOutButton')}
    </LogoutStyledButton>
  );
};
